import React from 'react';
import type { LucideIcon } from 'lucide-react';

export function statusToneClass(tone: 'success' | 'warn' | 'danger' | 'neutral') {
  return `tone-${tone}`;
}

export function Avatar({
  initials,
  className
}: {
  initials: string;
  className?: string;
}) {
  return (
    <div className={['avatar', className].filter(Boolean).join(' ')}>
      {initials}
    </div>
  );
}

export function ToneIcon({
  icon: Icon,
  tone
}: {
  icon: LucideIcon;
  tone: 'violet' | 'blue' | 'amber' | 'green';
}) {
  return (
    <span className={`toneIcon tone-${tone}`}>
      <Icon size={18} />
    </span>
  );
}

export function StatusChip({
  tone,
  children
}: {
  tone: 'success' | 'warn' | 'danger' | 'neutral';
  children: React.ReactNode;
}) {
  return (
    <span className={`statusChip ${statusToneClass(tone)}`}>{children}</span>
  );
}
